<template>
    <label v-if="label" class="control-label" :class="{ 'required-label': required }" :for="id">{{ label }}</label>
    <input ref="input" type="search" :id="id" v-model="value" :placeholder="placeholder" :maxlength="maxLength" :disabled="disabled" :required="required" :class="{ error: v$.value.$error }" autocomplete="off" class="form-control">
    <div v-if="v$.value.$error" class="invalid-msg">Поле обязательно для заполнения</div>
</template>

<script>
  import axios from 'axios';
  import { useVuelidate } from '@vuelidate/core';
  import { helpers } from '@vuelidate/validators';

  const requiredValidator = (required, scope) => helpers.withParams(
    { type: 'requiredValidator' },
    (value) => {
      if (!required) return true;
      return {
        $valid: value != null && String(value).trim().length > 0,
        extraParams: { scope }
      };
    }
  );

  export default {
    name: "AutocompleteInput",
    props: {
      modelValue: String,
      id: {
        type: [String, Number],
        required: true
      },
      url: {
        type: String,
        required: true
      },
      limit: {
        type: Number,
        default: 10
      },
      placeholder: String,
      label: String,
      maxLength: [String, Number],
      disabled: Boolean,
      required: Boolean,
      scopeName: String,
      minLength: {
        type: Number,
        default: 3
      },
      menuClass: String
    },
    emits: ['update:modelValue', 'select'],
    mounted() {
      const autocomplete = $(this.$refs.input).autocomplete({
        source: (request, response) => {
          axios.get(this.url, { params: { query: request.term, limit: this.limit } })
            .then((res) => {
              response(res.data.success ? res.data.items : []);
            })
            .catch(() => response([]));
        },
        select: (event, ui) => {
          this.value = ui.item.label;
          this.$emit('select', this.value);
          return true;
        },
        minLength: this.minLength,
        delay: 600
      });
      if (this.menuClass) {
        autocomplete.autocomplete('widget').addClass(this.menuClass);
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        value: {
          requiredValidator: requiredValidator(this.required, this.scopeName)
        }
      };
    },
    beforeUnmount() {
      $(this.$refs.input).autocomplete('destroy');
    },
    computed: {
      value: {
        get() {
          return this.modelValue;
        },
        set (value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .required-label::after {
        content: "*";
        color: red;
    }

    .form-control {
        max-width: 100% !important;
        width: 100%;
        background: #fff;
        border: 1px solid #D7D7E0;
        border-radius: 6px;
        box-sizing: border-box;
    }

    .form-control:disabled {
        background: #F5F5FA;
    }

    .invalid-msg {
        color: red;
        font-size: 0.75rem;
    }
</style>

<style lang="scss">
    .document-issuer-suggestions.ui-autocomplete {
        max-height: 280px;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #dee2e6;
        border-radius: 0 0 12px 12px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, .15);
        padding: 6px 0;
        background: #fff;
        z-index: 1050;
    }

    .document-issuer-suggestions .ui-menu-item-wrapper {
        box-sizing: border-box;
        max-width: 100%;
        padding: 8px 14px;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .document-issuer-suggestions.ui-menu .ui-state-active {
        margin: 0;
        border: 0;
        background: #f1f5f9;
        color: #212529;
    }
</style>
